import {IRole, IUserFormData} from "../UsersCRUD.types";
import {getRoleIDs} from "./getRolesId";

interface IUserPayload {
    inputData: IUserFormData;
    roles: IRole[];
    userId?: number;
    clientId: number
    is2FA: boolean
    permissions:string[]
}

export const createUserPayload = ({inputData, roles, userId, clientId, is2FA,permissions}: IUserPayload) => {
    if (userId) {
        return {
            id: userId,
            roles: getRoleIDs(inputData.userRole, roles)!,
            email: inputData.userEmail,
            name: inputData.userName,
            clientId: clientId ? clientId : null,
            is2FA,
            permissions
        }
    }

    return {
        roles: getRoleIDs(inputData.userRole, roles)!,
        email: inputData.userEmail,
        name: inputData.userName,
        password: inputData.userPassword!,
        clientId: clientId ? clientId : null,
        is2FA,
        permissions
    }
}
